export default __webpack_public_path__ + "static/media/backpffoc-v2.afc68000.webp";